export function getActiveTabNavigationKeySuffix(
  activeTabValues: Record<string, string>
): string {
  const entries = Object.entries(activeTabValues);

  if (entries.length === 0) {
    return '';
  }

  return entries
    .sort(([leftGroupId], [rightGroupId]) =>
      leftGroupId.localeCompare(rightGroupId)
    )
    .map(([groupId, tabId]) => `${groupId}=${tabId}`)
    .join('&');
}
